import React, { Fragment } from "react";

import classnames from "classnames";
import { renewalOverviewURL } from "EmployerApplication/urls";
import isIntuit from "Intuit/isIntuit";
import { flow } from "lodash";
import { showExtraPlans, hideExtraPlans } from "QuotePage/Actions";
import { getSortedFavoritePlans, getFavoritePlanIDs, NoFavoritePlans } from "QuotePage/Components/FavoritePlan";
import { PlanCard } from "QuotePage/Components/PlanCard";
import { StartApplicationButton, MoreDetailsButton, DefaultRenewalButton, ChangeRenewalButton } from "QuotePage/Components/PlanCardButtons";
import StatefulEnrolledPlanCard from "QuotePage/Components/StatefulEnrolledPlanCard";
import {
  getFilteredPlans,
  getNumEmployeeProfiles,
  getNumDependents,
  getVisiblePlansCompactQuotePage,
  isShowingExtraPlans,
  getHideablePlansCount,
  getSortOrder,
  getMedicalPlanEnrolledId,
  getMedicalPlanRenewalId,
  getPlanPackageIds,
  getPlanPackages,
  hasPlansBeforeInitialData,
} from "QuotePage/Selectors";
import { isRenewal } from "QuotePage/urls";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import { companyTokenString } from "Utils/companyToken";
import writtenNumber from "written-number";
import { baseUrl as basename } from "ZeroRuby/urls";

import CobaltAlert from "Cobalt/Alert";
import { Callout } from "Cobalt/Callout";
import Header, { TitleSmall } from "Cobalt/Header";
import { ReduxTriggerButton } from "Cobalt/Modal";
import Stack from "Cobalt/Stack";
import AgentImg from "Common/Agent/AgentImg";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import EnterAgesComponent from "Common/EnterAges/Components/EnterAgesComponent";
import { Grid, Col, Row } from "Common/Grid";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import { isLoadingPlans } from "Common/PlanLoader";
import { getPlans } from "Common/PlanLoader/Selectors";
import { SizeSwitch } from "Common/Responsive";
import ScrollToTopOnMount from "Common/ScrollToTopOnMount";
import { showExpandingFaq } from "Common/Selectors";
import ToggleCard from "Common/ToggleCard";
import { appendAuthParams } from "Common/TokenAuth/Utils";

import CustomVisiblePlans from "./compactQuotePage/CustomVisiblePlans";
import MobileFilterBar from "./compactQuotePage/MobileFilterBar";
import NoPlansCard from "./compactQuotePage/NoPlansCard";
import NoPlanSuiteCard from "./compactQuotePage/NoPlanSuiteCard";
import PaginatingFAQs from "./compactQuotePage/PaginatingFAQs";
import PlansFilterPanel from "./compactQuotePage/PlansFilterPanel";
import PlanSortDropdown from "./compactQuotePage/PlanSortDropdown";
import PricingStatusBanner from "./compactQuotePage/PricingStatusBanner";
import RecommendationVisiblePlans from "./compactQuotePage/RecommendationVisiblePlans";
import SavedPlansTray from "./compactQuotePage/SavedPlansTray";
import { getRecommendationMode } from "./compactQuotePage/Selectors";
import ShoppingTabs from "./compactQuotePage/ShoppingTabs";
import DentalQuotePage from "./DentalQuotePage/App";
import MECQuotePage from "./MECQuotePage";
import LoadingOverlay from "./shared/LoadingOverlay";
import PlanPackageCard from "./shared/PlanPackageCard";
import { RecommendationSurveyCard } from "./shared/RecommendationSurveyCard";

import type { Dispatch } from "redux";
import type { Plan, RecommendationMode, MedicalPlanPrice } from "Utils/types";

import makeBem from "Utils/makeBem";

const ANALYTICS_LOCATION = "compact_quote_page";

type Props = {
  isLoadingPlans: boolean;
  allPlansLength: number;
  totalItems: number;
  comparePlanIds: Array<string>;
  isShowingExtraPlans: boolean;
  visiblePlans: Array<Plan> | Array<MedicalPlanPrice>;
  city: string;
  state: string;
  handleHideExtraPlans: () => void;
  handleShowExtraPlans: () => void;
  onClickContactUs: () => void;
  hideablePlansCount: number;
  currentSort: string;
  numEmployees: number;
  numDependents: number;
  recommendationMode: RecommendationMode;
  medicalPlanEnrolledId: string;
  medicalPlanRenewalId: string;
  recommendedPlans: Array<Record<string, any>>;
  planPackageIds: Array<string>;
  planPackages: Array<Record<string, any>>;
  showExpandingFaq: boolean;
};

export class CompactQuotePageDumb extends React.Component<Props> {
  render() {
    return (
      <>
        <LoadingOverlay />
        <ScrollToTopOnMount />
        {/* TO-DO: needs a dynamic solution */}
        {this.props.state && this.props.companyProfile && this.props.companyProfile.target_effective_date && (
          <PricingStatusBanner geographicState={this.props.state} targetEffectiveDate={this.props.companyProfile.target_effective_date} />
        )}

        {this.props.userExperienceFlags?.show_cleared_plans_banner && (
          <Div className="mx-auto w-full max-w-screen-lg mt-4 mb-6">
            <Div className="h-full w-full lg:w-10/12 lg:ml-1/12">
              <CobaltAlert color="warning">
                The plan you previously added to your cart is no longer offered by insurance carriers. Please select from the current plan options below.
              </CobaltAlert>
            </Div>
          </Div>
        )}

        {this.props.deadlineToChangeRenewal && new Date() > this.props.deadlineToChangeRenewal && (
          <Div className="mx-auto w-full max-w-screen-lg mt-4 mb-6">
            <Div className="h-full w-full lg:w-10/12 lg:ml-1/12">
              <Callout
                type="warning"
                showIcon
                title="Deadline to Make Changes has Passed"
                body={
                  <>
                    You are past the deadline to make plan changes at renewal. If you would like to make changes, contact{" "}
                    <a className="alert-link" href="mailto:renewals@simplyinsured.com">
                      renewals@simplyinsured.com
                    </a>
                    .
                  </>
                }
              />
            </Div>
          </Div>
        )}

        {this.props.userExperienceFlags?.out_of_state_issue && (
          <Div className="mx-auto w-full max-w-screen-lg mt-4 mb-6">
            <Div className="h-full w-full lg:w-10/12 lg:ml-1/12">
              <CobaltAlert color="info">We've updated your plan filters to show plans that support Out-Of-State coverage.</CobaltAlert>
            </Div>
          </Div>
        )}

        <Div className={makeBem("QuotePageSubHeader")("GrayContainer")}>
          <Grid>
            {isRenewal() && (
              <Row mt="4" mb="4">
                <Col lg={10} lgOffset={1}>
                  <Button color="gray" size="medium" href={appendAuthParams(`${basename}${companyTokenString()}${renewalOverviewURL}`)}>
                    Return to Renewal Overview
                  </Button>
                </Col>
              </Row>
            )}

            <Row>
              <Col lg={10} lgOffset={1}>
                <EnterAgesComponent />
              </Col>
            </Row>
          </Grid>
        </Div>
        <Div className={makeBem("QuotePageSubHeader")("GrayContainer")}>
          <Grid>
            <Row>
              <Col lg={10} lgOffset={1}>
                <PaginatingFAQs />
              </Col>
            </Row>
          </Grid>
        </Div>
        <Grid mt={4}>
          <Row>
            <Col lg={10} lgOffset={1} style={{ paddingBottom: "0px" }}>
              <ShoppingTabs planPackagesAvailable={this.props.planPackageIds && this.props.planPackageIds.length > 0} />

              {this.renderContent()}
            </Col>
          </Row>
        </Grid>
        {this.renderComparePlansTray()}
      </>
    );
  }

  renderContent() {
    const customPlansSet = this.props.recommendedPlans && this.props.recommendedPlans.length > 0;

    if (this.props.recommendationMode === "recommended") {
      if (customPlansSet) {
        return this.renderCustomRecommendation();
      }
      return this.renderDefaultRecommendation();
    }
    if (this.props.recommendationMode === "multiple_plans") {
      return this.renderPlanPackages();
    }
    if (this.props.recommendationMode === "dental_plans") {
      return this.renderAllDentalPlans();
    }
    if (this.props.recommendationMode === "favorite_plans") {
      return this.renderFavoritePlans();
    }
    if (this.props.recommendationMode === "limited_value_plans") {
      return this.renderMECPlans(this.props.recommendationMode);
    }
    return this.renderAllPlans();
  }

  renderPlanPackages() {
    const { planPackages } = this.props;

    return (
      <>
        <Div className="flex" mb={5}>
          <Div ml={4}>
            <AgentImg size="tiny" />
          </Div>

          <BodyText>
            Many employers choose to offer multiple plans to their employees, because it allows them to control their budget while also giving their employee
            the option to pay a little bit more for better coverage.
          </BodyText>
        </Div>
        <Div style={{ display: "flex", paddingBottom: "4px" }}>
          <Header level={7}>Multiple Plan Packages</Header>
        </Div>
        <Stack direction="vertical">
          {planPackages.map((planPackage, i) => (
            <PlanPackageCard key={i} planPackage={planPackage} />
          ))}
        </Stack>
      </>
    );
  }

  renderCustomRecommendation() {
    return (
      <>
        <Div className={classnames("flex", { AgentHeader: true })} mb={5} style={{ justifyContent: "flex-start" }}>
          <Div ml={4}>
            <AgentImg size="tiny" />
          </Div>

          <BodyText agent className="hasGrayBackground">
            Thanks for completing the survey! Here are the plans I selected for you and your employees, based on your responses.
          </BodyText>
        </Div>
        {this.renderCustomPlansHeaderText()}
        <CustomVisiblePlans />
        {this.renderNoPlanSuiteCard()}
        <RecommendationSurveyCard location="recommendation_tab" customPlansSet />
      </>
    );
  }

  renderDefaultRecommendation() {
    return (
      <>
        <Div className="flex" mb={5} style={{ justifyContent: "flex-start" }}>
          <Div ml={4}>
            <AgentImg size="tiny" />
          </Div>
          <BodyText ml={4}>
            Welcome! I'm Leigh, your virtual insurance expert. I've put together some general recommendations for plans in your area below. If none of these
            match what you're looking for, you can take a short survey to help us better match you with a plan.
          </BodyText>
        </Div>
        {this.renderBestPlansHeaderText()}
        <RecommendationVisiblePlans />
        {this.renderNoPlanSuiteCard()}
        {this.props.allPlansLength > 0 && <RecommendationSurveyCard location="recommendation_tab" customPlansSet={false} />}
      </>
    );
  }

  renderAllDentalPlans() {
    return <DentalQuotePage />;
  }

  renderAllPlans() {
    return (
      <>
        {this.renderFilters()}
        {this.renderPinnedCards()}
        {!isRenewal() && this.renderBestPlans()}
        {this.renderOtherPlans()}
        {this.renderNoPlansCard()}
        {this.renderNoPlanSuiteCard()}
        {this.renderToggleExtraPlansButton()}
      </>
    );
  }

  renderFilters() {
    return (
      <Div mb={5}>
        <SizeSwitch xs={<MobileFilterBar />} sm={<PlansFilterPanel />} />
      </Div>
    );
  }

  renderPersonalizationText() {
    const { numEmployees, numDependents } = this.props;
    const text =
      numEmployees > 0
        ? `Exact quote for ${writtenNumber(numEmployees)} employee${numEmployees == 1 ? "" : "s"} and ${writtenNumber(numDependents)} dependent${
            numDependents == 1 ? "" : "s"
          }`
        : "*Sample quote for 30 year old employee";

    return (
      <BodyText componentClass="span" weight="normal" pl={2}>
        ({text})
      </BodyText>
    );
  }

  renderBestPlans() {
    const { city, state, currentSort } = this.props;

    let regionCopy;
    if (city && state) {
      regionCopy = `${city}, ${state}`;
    } else if (city) {
      regionCopy = `${city}`;
    } else {
      regionCopy = `Your Area`;
    }

    const displayText = `${currentSort == "score" ? "Best Plans " : "Plans "}`;

    return (
      <div data-testid="QuotePage__BestPlans">
        <Stack direction="horizontal" justify="space-between" align="baseline">
          <TitleSmall>
            {displayText}
            <span className="max-md:hidden">{` in ${regionCopy}`}</span>
            <SizeSwitch sm={this.renderPersonalizationText()} />
          </TitleSmall>
          <PlanSortDropdown />
        </Stack>
        {currentSort == "score" && this.renderPlanSlice(0, 3)}
      </div>
    );
  }

  renderCustomPlansHeaderText() {
    return (
      <div>
        <Div style={{ display: "flex" }}>
          <Header level={7} pb={isIntuit() ? 0 : 2}>
            Your Custom Recommendations
          </Header>
        </Div>
      </div>
    );
  }

  renderBestPlansHeaderText() {
    const { city, state } = this.props;

    let regionCopy;
    if (city && state) {
      regionCopy = `${city}, ${state}`;
    } else if (city) {
      regionCopy = `${city}`;
    } else {
      regionCopy = `Your Area`;
    }

    return (
      <div>
        <Div style={{ display: "flex" }}>
          <Header level={7} pb={isIntuit() ? 0 : 2}>
            Best Plans <span className="max-md:hidden">{`in ${regionCopy}`}</span>
            <SizeSwitch sm={this.renderPersonalizationText()} />
          </Header>
        </Div>
      </div>
    );
  }

  renderContactUsButton() {
    return (
      <ReduxTriggerButton fullWidth name="contactUsModal" onClick={this.props.onClickContactUs} color="link">
        <Icon icon="phone" mr={2} flavor="solid" />
        Contact Us
      </ReduxTriggerButton>
    );
  }

  renderOtherPlans() {
    const { visiblePlans, currentSort } = this.props;
    const planSliceIndex = currentSort == "score" && !isRenewal() ? 3 : 0;

    if (visiblePlans.length <= 3) {
      return null;
    }

    let otherPlansHeader;

    if (isRenewal()) {
      otherPlansHeader = (
        <Div style={{ display: "flex" }} mt={isIntuit() ? 3 : 4}>
          <Header level={7}>Alternative Plan Options</Header>
          <Div style={{ marginLeft: "auto" }}>
            <PlanSortDropdown />
          </Div>
        </Div>
      );
    } else if (currentSort == "score") {
      otherPlansHeader = (
        <Header level={7} mt={isIntuit() ? 3 : 4} pb={isIntuit() ? 0 : 2}>
          Other Plans
        </Header>
      );
    }

    return (
      <div data-testid="QuotePage__OtherPlans">
        {otherPlansHeader}
        {this.renderPlanSlice(planSliceIndex)}
      </div>
    );
  }

  renderPlanSlice(index: number, count?: number) {
    const { visiblePlans, medicalPlanEnrolledId, medicalPlanRenewalId, renewalPlanBrand } = this.props;

    const pinnedPlansIds = new Set([medicalPlanEnrolledId, medicalPlanRenewalId]);

    const nonPinnedPlans = visiblePlans.filter((p) => !pinnedPlansIds.has(p.id)) || [];

    return (
      nonPinnedPlans.length > 0 &&
      nonPinnedPlans.slice(index, count).map((plan) => (
        <PlanCard key={plan.id} planId={plan.id}>
          <Stack direction="horizontal" justify="space-between" align="center">
            <MoreDetailsButton planId={plan.id} />
            {isRenewal() ? <ChangeRenewalButton planId={plan.id} /> : <StartApplicationButton planId={plan.id} />}
          </Stack>
        </PlanCard>
      ))
    );
  }

  renderNoPlansCard() {
    if (!this.props.isLoadingPlans && this.props.totalItems == 0 && this.props.allPlansLength > 0 && this.props.recommendationMode !== "recommended") {
      return <NoPlansCard />;
    }
    return null;
  }

  renderNoPlanSuiteCard() {
    if (!this.props.isLoadingPlans && this.props.totalItems == 0 && !(this.props.allPlansLength > 0)) {
      return <NoPlanSuiteCard />;
    }
    return null;
  }

  renderToggleExtraPlansButton() {
    const { isShowingExtraPlans, handleHideExtraPlans, handleShowExtraPlans, hideablePlansCount } = this.props;

    if (!hideablePlansCount) {
      return null;
    }

    const labelCopy = isShowingExtraPlans ? `Hide ${hideablePlansCount} plans` : `Show ${hideablePlansCount} more plans`;

    const onClick = isShowingExtraPlans ? handleHideExtraPlans : handleShowExtraPlans;

    return <ToggleCard mt={4} onClick={onClick} label={labelCopy} isUp={isShowingExtraPlans} />;
  }

  renderComparePlansTray() {
    if (this.props.comparePlanIds.length > 0) {
      return <SavedPlansTray />;
    }
    return null;
  }

  renderPinnedCards() {
    let row = null;
    const currentPlan = this.renderMedicalEnrolledCard();
    const defaultRenewal = this.renderMedicalRenewalCard();

    if (currentPlan || defaultRenewal) {
      row = [
        <Header level={7} pb={isIntuit() ? 0 : 2}>
          Current Plan
          {this.props.medicalPlanRenewalId && " and Default Renewal"}
        </Header>,
        currentPlan,
        defaultRenewal,
      ];
    }

    return row;
  }

  renderFavoritePlans() {
    // Select the plan objects instead of the IDs directly, which waits for them to load in.
    // Then send the IDs to be rendered.
    const { favoritePlans } = this.props;
    const favoritePlanCards =
      favoritePlans.length > 0 &&
      favoritePlans.map((plan) => {
        return (
          <PlanCard key={plan.id} planId={plan.id}>
            <MoreDetailsButton planId={plan.id} />
            {isRenewal() ? <ChangeRenewalButton planId={plan.id} /> : <StartApplicationButton planId={plan.id} />}
          </PlanCard>
        );
      });

    const { favoritePlanIDs } = this.props;
    const favoritePlansHeader =
      favoritePlanIDs.length > 0 ? (
        <Div style={{ display: "flex" }} mt={4} mb={4}>
          <Header level={7}>Favorite Plans</Header>
          <Div style={{ marginLeft: "auto" }}>
            <PlanSortDropdown />
          </Div>
        </Div>
      ) : null;

    const noFavoritePlans = favoritePlanIDs.length > 0 ? null : <NoFavoritePlans />;

    return (
      <>
        {favoritePlansHeader}
        {favoritePlanCards}
        {noFavoritePlans}
      </>
    );
  }

  renderMECPlans() {
    return <MECQuotePage />;
  }

  renderMedicalEnrolledCard() {
    const { medicalPlanEnrolledId } = this.props;
    return medicalPlanEnrolledId && <StatefulEnrolledPlanCard />;
  }

  renderMedicalRenewalCard() {
    const { medicalPlanRenewalId } = this.props;
    return (
      medicalPlanRenewalId && (
        <PlanCard planId={medicalPlanRenewalId}>
          <MoreDetailsButton planId={medicalPlanRenewalId} />
          <DefaultRenewalButton planId={medicalPlanRenewalId} />
        </PlanCard>
      )
    );
  }
}

const mapStateToProps = (state) => {
  const planPackages = getPlanPackages(state);
  const visiblePlans = getVisiblePlansCompactQuotePage(state);
  const medicalPlanRenewalId = getMedicalPlanRenewalId(state);
  const { companyProfile } = state;
  const deadlineToChangeRenewal = companyProfile.deadlineToChangeRenewal ? new Date(companyProfile.deadlineToChangeRenewal) : null;

  return {
    companyProfile,
    comparePlanIds: state.savedPlanIDs,
    visiblePlans,
    favoritePlans: getSortedFavoritePlans(state),
    favoritePlanIDs: getFavoritePlanIDs(state),
    allPlansLength: getPlans(state).length,
    totalItems: getFilteredPlans(state).length,
    isLoadingPlans: isLoadingPlans(state),
    isShowingExtraPlans: isShowingExtraPlans(state),
    city: state.city,
    state: state.state,
    hideablePlansCount: getHideablePlansCount(state),
    currentSort: getSortOrder(state),
    numEmployees: getNumEmployeeProfiles(state),
    numDependents: getNumDependents(state),
    recommendationMode: getRecommendationMode(state),
    medicalPlanEnrolledId: getMedicalPlanEnrolledId(state),
    medicalPlanRenewalId,
    renewalPlanBrand: visiblePlans.find((p) => p.id == medicalPlanRenewalId)?.plan_brand_symbol,
    recommendedPlans: state.recommendedPlans,
    planPackageIds: getPlanPackageIds(state),
    planPackages,
    showExpandingFaq: showExpandingFaq(state),
    userExperienceFlags: state.userExperienceFlags,
    disableButtons: hasPlansBeforeInitialData(state),
    deadlineToChangeRenewal,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  handleShowExtraPlans: () => {
    AnalyticsTracking.trackEvent("show_extra_plans", {
      location: ANALYTICS_LOCATION,
    });

    dispatch(showExtraPlans());
  },
  handleHideExtraPlans: () => {
    AnalyticsTracking.trackEvent("hide_extra_plans", {
      location: ANALYTICS_LOCATION,
    });

    dispatch(hideExtraPlans());
  },
  onClickContactUs: () => {
    AnalyticsTracking.trackEvent("clicked_contact_us", {
      location: ANALYTICS_LOCATION,
    });
  },
});

const CompactQuotePage = flow(connect(mapStateToProps, mapDispatchToProps), withRouter)(CompactQuotePageDumb);

export default CompactQuotePage;
